import { toast } from 'react-toastify';
import { IBtnProps } from './CoreTypes';
import Icon, { IconType } from '../Icon/Icon';
import StoreX from '../../redux/oldStore';

const Button = (props: IBtnProps) => {
  const getIcon = () => {
    if (!props.type) return <></>;

    switch (props.type) {
      case 'cancel':
        return <Icon type={IconType.ban} />;
      case 'close':
        return <Icon type={IconType.close} />;
      case 'delete':
      case 'remove':
        return <Icon type={IconType.remove} />;
      case 'open':
        return <Icon type={IconType.signIn} />;
      case 'save':
        return <Icon type={IconType.save} />;
      case 'new':
        return <Icon type={IconType.new} />;
      case 'copy':
        return <Icon type={IconType.copy} />;
      case 'edit':
        return <Icon type={IconType.edit} />;
      case 'edit-dots':
        return <Icon type={IconType.dots} />;
      case 'refresh':
        return <Icon type={IconType.refresh} />;
      case 'login':
        return <Icon type={IconType.signIn} />;
      case 'logout':
        return <Icon type={IconType.signOut} />;
      case 'register':
        return <Icon type={IconType.userPlus} />;
      case 'on':
        return <Icon type={IconType.on} />;
      case 'off':
        return <Icon type={IconType.off} />;
      case 'download':
        return <Icon type={IconType.download} />;
      case 'upload':
        return <Icon type={IconType.upload} />;
      case 'send':
        return <Icon type={IconType.send} />;
      case 'details':
        return <Icon type={IconType.info} />;
      case 'up':
        return <Icon type={IconType.up} />;
      case 'down':
        return <Icon type={IconType.down} />;
      case 'good':
        return <Icon type={IconType.approve} />;
      case 'bad':
        return <Icon type={IconType.reject} />;
      case 'approve':
        return <Icon type={IconType.approve} />;
      case 'reject':
        return <Icon type={IconType.reject} />;
      case 'pending':
        return <Icon type={IconType.pending} />;
      case 'settings':
        return <Icon type={IconType.configure} />;
      case 'next':
        return <Icon type={IconType.next} />;
      case 'previous':
        return <Icon type={IconType.back} />;
      case 'locked':
        return <Icon type={IconType.lock} />;
      case 'un-locked':
        return <Icon type={IconType.unlock} />;
      // case 'add':
      //   return <Icon type={IconType.add} />;
      // case 'remove':
      //   return <Icon type={IconType.remove} />;
      // case 'search':
      //   return <Icon type={IconType.search} />;
      // case 'filter':
      //   return <Icon type={IconType.filter} />;
      // case 'print':
      //   return <Icon type={IconType.print} />;
      // case 'view':
      //   return <Icon type={IconType.view} />;
      // case 'settings':
      //   return <Icon type={IconType.settings} />;
      // case 'info':
      //   return <Icon type={IconType.info} />;
      // case 'help':
      //   return <Icon type={IconType.help} />;
      // case 'check':
      //   return <Icon type={IconType.check} />;
      // case 'uncheck':
      //   return <Icon type={IconType.remove} />;
    }
    return <></>;
  };

  const getIconOnlyStyle = () => {
    let styles = ['text'];

    switch (props.type) {
      case 'cancel':
        styles.push('text-default');
        break;
      case 'close':
        styles.push('text-default');
        break;
      case 'delete':
      case 'remove':
        styles.push('text-danger');
        break;
      case 'open':
        styles.push('text-info');
        break;
      case 'save':
      case 'login':
        styles.push('text-secondary');
        break;
      case 'new':
        styles.push('text-success');
        break;
      case 'edit':
      case 'edit-dots':
      case 'register':
      case 'download':
      case 'upload':
      case 'copy':
        styles.push('text-default');
        break;
      case 'refresh':
        styles.push('text-default');
        break;
      case 'on':
        styles.push('text-info');
        break;
      case 'good':
        styles.push('text-success');
        break;
      case 'bad':
        styles.push('text-danger');
        break;
      case 'approve':
        styles.push('text-success');
        break;
      case 'reject':
        styles.push('text-danger');
        break;
      case 'pending':
        styles.push('text-warning');
        break;
      case 'locked':
        styles.push('text-danger');
        break;
      case 'un-locked':
        styles.push('text-muted');

        break;
    }

    if (props.extraSmall) styles.push('text-xs');

    if (props.addClass) styles.push(props.addClass);
    return styles.join(' ');
  };

  const getStyle = () => {
    let styles = ['btn'];

    switch (props.type) {
      case 'cancel':
        styles.push('btn-default');
        break;
      case 'close':
        styles.push('btn-default');
        break;
      case 'delete':
      case 'remove':
        styles.push('btn-danger');
        break;
      case 'open':
      case 'on':
        styles.push('btn-info');
        break;
      case 'save':
      case 'login':
        styles.push('btn-secondary');
        break;
      case 'new':
        styles.push('btn-success');
        break;
      case 'edit':
      case 'edit-dots':
      case 'register':
      case 'download':
      case 'upload':
      case 'copy':
        styles.push('btn-default');

        break;
      case 'good':
        styles.push('btn-success');
        break;
      case 'bad':
        styles.push('btn-danger');
        break;
      case 'approve':
        styles.push('btn-success');
        break;
      case 'reject':
        styles.push('btn-danger');
        break;
      case 'pending':
        styles.push('btn-warning');
        break;
    }

    if (props.extraSmall) styles.push('btn-xs');

    if (props.addClass) styles.push(props.addClass);
    return styles.join(' ');
  };

  const onClick = () => {
    if (props.disabled) return;

    if (!props.onClick) {
      toast.dark('do something special!');
    } else {
      props.onClick();
    }
  };

  return (
    <>
      {props.iconOnly ? (
        <span className={`icon-btn ${getIconOnlyStyle()}`} aria-disabled={props.disabled ? true : false} onClick={onClick} title={props.title}>
          {getIcon()}
          {props.text && <>{props.text}</>}
        </span>
      ) : (
        <button type={'button'} disabled={props.disabled ? true : false} className={getStyle()} onClick={onClick} title={props.title || props.text}>
          {getIcon()}
          {props.text && !props.iconOnly && <>{props.text}</>}
        </button>
      )}
    </>
  );
};

export default Button;
